import { verificationQueryKeys as e } from "./useVerificationQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { verificationApi as r } from "@maat/api-main";
//#region src/verification/useStartDiditSessionMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: r.startIdentityVerificationSession,
		retry: !1,
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.identity() });
		}
	});
};
//#endregion
export { i as useStartDiditSessionMutation };
